import { CircleCheck } from "lucide-react";
import React, { useEffect } from "react";
import { useImmer } from "use-immer";

import {
  IgButton,
  IgDivider,
  IgPaper,
  IgTextField,
  IgTypography,
} from "@intelligems/ig-theme";
import { BaseIntegrationDto } from "@intelligems/ig-types";
import { Grid, useTheme } from "@mui/material";

import { usePutIntegration } from "../../../../api/integrations/put-integration";

interface StayAiIntegrationProps {
  stayAiIntegration?: BaseIntegrationDto<any, { apiKey: string }>;
}

export const StayAiIntegration = ({
  stayAiIntegration,
}: StayAiIntegrationProps) => {
  const [mode, setMode] = useImmer<"view" | "edit">("view");
  const [apiKey, setApiKey] = useImmer<string>("");
  const theme = useTheme();
  useEffect(() => {
    if (stayAiIntegration?.enabled) {
      setApiKey("****************");
    }
  }, [stayAiIntegration?.enabled]);

  const putIntegration = usePutIntegration();

  const onSaveClick = () => {
    putIntegration.mutate({
      body: {
        name: "StayAi",
        accessToken: apiKey,
      },
      pathParams: undefined,
      queryParams: undefined,
    });
  };

  return (
    <IgPaper sx={{ boxShadow: "none" }}>
      <Grid
        container
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid item>
          <Grid container item alignItems={"center"} columnSpacing={2}>
            {stayAiIntegration?.enabled ? (
              <Grid item>
                <CircleCheck size={24} color={theme.igIconColors.success} />
              </Grid>
            ) : null}
            <Grid item>
              <IgTypography
                variant={"h3"}
                sx={{
                  fontWeight: 600,
                }}
              >
                Stay.ai
              </IgTypography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item>
          <IgButton
            variant={"contained"}
            onClick={() => {
              setMode("edit" === mode ? "view" : "edit");
            }}
          >
            {mode === "edit" ? "Cancel" : stayAiIntegration ? "Edit" : "Enable"}
          </IgButton>
        </Grid>
      </Grid>
      {mode === "edit" ? (
        <Grid container item direction={"column"}>
          <Grid item>
            <IgDivider spacing={"s"} />
          </Grid>
          <Grid container item alignItems={"center"} columnSpacing={2}>
            <Grid item>
              <IgTypography sx={{ fontWeight: 600 }}>
                Stay.ai API Key:
              </IgTypography>
            </Grid>
            <Grid item xs={4}>
              <IgTextField
                fullWidth={true}
                onChange={(e) => {
                  setApiKey(e.target.value);
                }}
                value={apiKey}
              />
            </Grid>
            <Grid item>
              <IgButton
                disabled={apiKey.includes("*") || apiKey.length === 0}
                variant={"outlined"}
                onClick={onSaveClick}
                loading={putIntegration.isPending}
              >
                Save
              </IgButton>
            </Grid>
          </Grid>
        </Grid>
      ) : null}
    </IgPaper>
  );
};
